import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MuiButton from '@mui/material/Button';
import PropTypes from 'prop-types';

function Button({
  children,
  label,
  leading,
  trailing,
  sx,
  ...props
}) {
  return (
    <MuiButton
      startIcon={leading && <FontAwesomeIcon icon={leading} />}
      endIcon={trailing && <FontAwesomeIcon icon={trailing} />}
      sx={{
        whiteSpace: 'normal',
        height: 'auto',
        ...sx,
        '.MuiButton-startIcon>*:nth-of-type(1)': { fontSize: 'inherit', marginBottom: leading ? '4px' : 0, marginRight: leading ? '4px' : 0 },
        '.MuiButton-endIcon>*:nth-of-type(1)': { fontSize: 'inherit' },
      }}
      {...props}
    >
      {label}{children}
    </MuiButton>
  );
}

Button.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  leading: PropTypes.string,
  trailing: PropTypes.string,
};

export default Button;
